import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { MatChipsModule } from '@angular/material/chips'
import {
  BalanceChipColor,
  EstimateBalanceWorkflowStatus,
  workflowStatusChipColor,
} from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

const WORKFLOW_KEY: Record<EstimateBalanceWorkflowStatus, string> = {
  [EstimateBalanceWorkflowStatus.DRAFT]: 'balance.workflow-status.draft',
  [EstimateBalanceWorkflowStatus.CONFIRMED]: 'balance.workflow-status.confirmed',
  [EstimateBalanceWorkflowStatus.NA]: 'balance.workflow-status.na',
  [EstimateBalanceWorkflowStatus.NOT_READY]: 'balance.workflow-status.not-ready',
  [EstimateBalanceWorkflowStatus.NOT_STARTED]: 'balance.workflow-status.not-started',
}

@Component({
  selector: 'mmx-balance-status-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, MatChipsModule],
  templateUrl: './balance-status-chip.component.html',
  styleUrls: ['./balance-status-chip.component.scss'],
})
export class BalanceStatusChipComponent {
  @Input() status: EstimateBalanceWorkflowStatus = EstimateBalanceWorkflowStatus.DRAFT

  get color(): BalanceChipColor {
    return workflowStatusChipColor(this.status)
  }

  // mat-chip's `color` only accepts 'primary' | 'accent' | 'warn'. Muted is rendered via the .chip-muted class.
  get matChipColor(): 'primary' | 'accent' | 'warn' | null {
    return this.color === 'muted' ? null : this.color
  }

  get isMuted(): boolean {
    return this.color === 'muted'
  }

  get labelKey(): string {
    return WORKFLOW_KEY[this.status]
  }
}
